var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMadameAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12579_28178)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4393 27.8514C17.594 25.9314 20.2451 22.2511 26.5576 17.0799C36.0829 9.27656 27.0929 2.13911 17.435 5.94049C16.4019 6.34719 13.5389 4.71908 10.8869 6.4343C9.17616 7.54076 9.84194 8.40788 9.17581 9.27501C8.50969 10.1421 5.94156 10.0911 5.37897 12.3427C5.04577 13.6767 5.96783 15.074 5.8445 16.078C5.72117 17.082 4.74779 17.9871 4.70135 19.3126C4.68124 19.8724 4.77162 20.4307 4.96732 20.9556C5.16302 21.4805 5.46021 21.9617 5.84191 22.3717C6.22361 22.7817 6.68235 23.1125 7.19192 23.3452C7.7015 23.5779 8.25192 23.708 8.81175 23.7279C8.81633 24.8347 9.24847 25.8968 10.0179 26.6924C10.7873 27.488 11.8344 27.9554 12.9404 27.997C13.6495 28.0229 14.3539 27.8703 14.9888 27.5533C15.6187 28.1339 16.1595 28.3165 16.4393 27.8514Z",
    fill: "url(#paint0_linear_12579_28178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6672 25.8685C16.6672 24.6685 16.6264 18.7496 16.6284 18.6496C13.3339 19.1352 13.4006 12.8685 16.7339 14.4018C17.4672 14.8685 19.5339 14.4018 19.3339 10.5352C22.9339 14.4018 27.1135 9.89196 27.4719 13.5669C27.9614 18.5849 27.469 23.8364 24.3504 23.8368C24.0093 23.8326 23.6691 23.7986 23.3339 23.7352V25.8685C23.3339 27.2018 25.7339 27.8685 25.7339 27.8685C25.7339 27.8685 21.5883 31.7752 19.8672 31.7536C18.1462 31.732 14.2672 27.8685 14.2672 27.8685C14.2672 27.8685 16.6672 27.2018 16.6672 25.8685Z",
    fill: "url(#paint1_linear_12579_28178)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M23.3336 23.7359C21.6795 23.369 20.112 22.6854 18.7178 21.7227C18.7178 21.7227 19.8682 24.5351 23.3294 25.0687L23.3336 23.7359Z",
    fill: "url(#paint2_linear_12579_28178)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2666 31.8698C33.2339 34.0194 33.7333 40.5365 33.7333 40.5365H6.2666C6.2666 40.5365 6.76593 34.0194 7.73327 31.8698C8.58073 29.9867 14.1651 27.8246 15.8017 27.2031C16.7466 28.2602 18.1007 28.9365 19.9999 28.9365C21.8991 28.9365 23.2533 28.2602 24.1982 27.2031C25.8347 27.8246 31.4191 29.9867 32.2666 31.8698Z",
    fill: "url(#paint3_linear_12579_28178)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47702 31.9135C8.20262 30.5337 10.5908 29.0859 12.799 28.1101C13.9004 27.6234 17.2004 41.6035 17.2004 41.6035H6.14475C6.14475 41.6035 6.01155 34.7003 7.47702 31.9135Z",
    fill: "url(#paint4_linear_12579_28178)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12579_28178",
    x1: 18.0158,
    y1: 4.71363,
    x2: 17.1944,
    y2: 28.1568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D0024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#100014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12579_28178",
    x1: 20.9152,
    y1: 10.5352,
    x2: 20.9152,
    y2: 31.7536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6864E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB965E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12579_28178",
    x1: 19.5895,
    y1: 22.3519,
    x2: 20.2811,
    y2: 25.4632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F09960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12579_28178",
    x1: 19.9999,
    y1: 40.5365,
    x2: 19.9999,
    y2: 27.2031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC9B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12579_28178",
    x1: 11.671,
    y1: 41.6035,
    x2: 11.671,
    y2: 28.0977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF2EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF9F5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12579_28178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMadameAvatar);
export default __webpack_public_path__ + "static/media/madameAvatar.0bfd391597668e9c5b91d7c0fd2b1497.svg";
export { ForwardRef as ReactComponent };